import { useBackend } from "../../services";
import { EquipmentStatus, IEquipmentGearItem } from "./interfaces";

export const useModifyEquipment = () => {
  const { put } = useBackend();
  const modifyEquipment = (parameters: IModifyEquipmentParameters) => put("equipments", parameters);
  return { modifyEquipment };
};

export interface IModifyEquipmentParameters {
  uuid: string;
  name: string;
  description?: string;
  status: EquipmentStatus;
  gearItems: IEquipmentGearItem[];
}
